import { Color } from '@draughts/shared';

/**
 * Questo colore ha gia' giocato una mossa sua?
 *
 * La finestra «finche' non muovo io» prima era scritta come una regola di parita'
 * sui colori (`bianco: mosse === 0`, `nero: mosse <= 1`) che presuppone «di mano e'
 * il Bianco». Con l'apertura sorteggiata di tabella B — tre semi-mosse gia' sulla
 * scacchiera — di mano e' il **Nero**, e quella regola si rovescia: il Bianco
 * perdeva il turno di parola senza aver mai mosso, il Nero se lo teneva dopo aver
 * mosso.
 *
 * Chi ha appena mosso e' l'opposto di chi e' di turno adesso. Da li' il conto e'
 * esatto senza sapere chi fosse di mano:
 *
 *   ha mosso X  ⟺  mosse giocate >= (X ha appena mosso ? 1 : 2)
 *
 * Regge su aperture di qualunque lunghezza, pari o dispari, e sulle varianti dove
 * il primo di mano non e' il Bianco. La stessa domanda, lato server, la risponde
 * `GameRoom.haGiaMosso` con una bandiera invece che con un conto: quella e'
 * l'autorita', questa e' la sua derivazione a schermo. Serve a due schermate — il
 * boost d'arena e il saluto d'apertura — e per questo sta qui invece che dentro
 * uno dei due.
 *
 * `mosseGiocate` sono le mosse VERE, apertura forzata esclusa: vedi
 * `mosseGiocate()` qui sotto.
 */
export function haMosso(
  colore: 'white' | 'black',
  mosseGiocate: number,
  turnoCorrente: Color | null
): boolean {
  if (turnoCorrente === null) return mosseGiocate > 0;
  const appenaMosso = turnoCorrente === Color.WHITE ? 'black' : 'white';
  return mosseGiocate >= (colore === appenaMosso ? 1 : 2);
}

/**
 * Le semi-mosse giocate DAVVERO dai due giocatori: quelle dell'apertura
 * sorteggiata non sono mosse di nessuno.
 *
 * Stessa formula — `Math.max` compreso — di `GameRoom.getPlayedMoveCount()`: il
 * massimo protegge dall'edge in cui l'apertura fallisce a meta' e il chiamante
 * azzera il conto delle sue semi-mosse.
 */
export function mosseGiocate(plies: number, openingPlyCount: number): number {
  return Math.max(0, plies - openingPlyCount);
}
